/**
 * @creator Jaap
 * @date 21-04-2020
 */

import Cookies from "js-cookie";
import EventEmitter from "events";
import Analytics from "./utils/Analytics";
import Utils from "./utils/Utils";

export default class CookieConsent extends EventEmitter {
    constructor(settings) {
        super();

        this._mode = settings.mode;
        this._anonymous = settings.anonymous;
        this._analytics = new Analytics();

        if (settings.mode) {
            this._consented = Cookies.get("MaglrCookieConsent");

            if (this._consented) {
                this._consented = this._consented === "true";
            } else {
                this.show();
            }
            //set the window variable so the rest of the system can access it.
            window.MaglrCookieConsented = this._consented || false;

            this._consentChanged();
        }
    }

    show() {
        if (this._mode === 3) {
            if (!this._customCookieListener) {
                this._customCookieListener = (event) => {
                    this.setMaglrConsent(event.detail?.consented);
                };
                //document.dispatchEvent(new CustomEvent("MaglrCustomCookieConsent", {detail:{consented:true}}))
                document.addEventListener("MaglrCustomCookieConsent", this._customCookieListener);
                window.setMaglrConsent = this.setMaglrConsent.bind(this); // expose function for external use
            } else {
                document.dispatchEvent(Utils.createEvent("MaglrRequestShowCookieConsent"));
                this._analytics.setGTMData({ event: "maglrConsentRequested" });
            }
        } else {
            if (this._consented) {
                this.emit("ConsentChanged", { consent: this._consented });
                return;
            }
            if (!this.consentContainer) {
                if (!this.buttonClickHandler) {
                    this.buttonClickHandler = this._buttonClicked.bind(this);
                }
                this.consentContainer = document.getElementById("maglrConsentContainer");
                this.consentContainer
                    .querySelector(".buttonContainer")
                    .addEventListener("click", this.buttonClickHandler);
                this.consentContainer.style.display = "block";
                this.consentContainer.querySelector("button").focus();
            }
        }
    }

    close() {
        if (!this.consentContainer) {
            return;
        }
        this.consentContainer.style.display = "none";
        delete this.consentContainer;
    }

    _buttonClicked(event) {
        if (!event.target?.dataset?.maglrconsent) {
            return;
        }

        this.consentContainer.querySelector(".buttonContainer").removeEventListener("click", this.buttonClickHandler);
        if (event.target.dataset.maglrconsent === "accept") {
            this.accept();
        } else if (event.target.dataset.maglrconsent === "reject") {
            this.reject();
        }
        this.close();
    }

    accept() {
        this._setConsent(true);
    }

    reject() {
        this._setConsent(false);
    }

    getConsent() {
        return this._consented;
    }

    _setConsent(bool) {
        this._consented = bool;
        window.MaglrCookieConsented = this._consented;
        Cookies.set("MaglrCookieConsent", this._consented, { expires: 365 });

        this._consentChanged();
        this.emit("ConsentChanged", { consent: this._consented });
    }

    _consentChanged() {
        if (this._consented) {
            if (this._stashedGATracker) {
                window.gtag = this._stashedGATracker;
                delete this._stashedGATracker;
            }
            window.maglr_pirsch && (window.maglr_pirsch.disabled = false);

            if (this._anonymous === 0) {
                try {
                    window.gtag("set", {
                        anonymizeIp: false,
                        allowAdFeatures: true,
                    });
                } catch (error) {
                    console.error("MAGLR ERROR: [gtag.set]", error);
                }
            }
        } else {
            if (window.gtag || window.maglr_pirsch) {
                switch (this._mode) {
                    case 1:
                        // don't send analytics if cookies disabled
                        this._stashedGATracker = window.gtag;
                        window.gtag = undefined;
                        window.maglr_pirsch && (window.maglr_pirsch.disabled = true);
                        console.warn("Cookie consent active, so disabled the GA tracker");
                        break;
                    case 2:
                        try {
                            window.gtag("set", {
                                anonymizeIp: true,
                                allowAdFeatures: false,
                            });
                        } catch (error) {
                            console.error("MAGLR ERROR: [gtag.set]", error);
                        }
                        break;
                    case 3:
                        window.maglr_pirsch && (window.maglr_pirsch.disabled = true);
                        break;
                }
            }
        }

        if (this._consented !== undefined) {
            this._analytics.setGTMData({
                event: "maglrConsentChanged",
                maglrCookieConsented: this._consented,
            });
        }
    }

    getMode() {
        return this._mode;
    }

    setMaglrConsent(bool) {
        if (bool) {
            if (this._customCookieListener) {
                document.removeEventListener("MaglrCustomCookieConsent", this._customCookieListener);
                delete this._customCookieListener;
                this.accept();
            }
        } else {
            this.reject();
        }
    }

    showAgain() {
        this._setConsent(undefined);
        this.show();
    }
}
